import React, { Component } from 'react'
import { connect } from 'react-redux';
import { Modal, Button, message } from 'antd'
import { getUserScore, payForOrder_cart, payForOrder_search } from '../../service/actoin'
import store from '../../../../../store'
import axios from 'axios'
import defaultImg from '../../img/defaultImg.png'
import './payModal.css'

const payList = [
    {}
]

class PayModal extends Component {
    constructor(props) {
        super(props)
        this.state = {
            payFlag: false,
            userScore: 0,
            exScore: 0,
            loading: false
        }
    }

    componentDidMount() {
        // this.getUserScore();
        if (this.props.user.userId) this.getUserScore();
    }

    componentDidUpdate(preProps) {
        if (preProps.user.userId !== this.props.user.userId) {
            this.getUserScore();
        }
    }

    //获取用户拥有的积分
    getUserScore() {

        axios({
            url: global.url.score + '/score/getbyid',
            method: 'get',
            params: {
                userId: this.props.user.userId,
            },
            headers: {
                'Authorization': this.props.user.token
            }
        }, 
        ).then(res => {
            if (res.data.code === '200') {
                this.setState({ userScore: res.data.payload.score })
            } else {

                message.error('用户积分查询错误或用户积分不存在');
            }
        }).catch(err => {
            console.log(err);
            message.error('用户积分查询错误或用户积分不存在');
        })
    }

    payForOrder = async () => {

        try {

            let uScore = await getUserScore()
            let exScore = Number(uScore) - Number(this.props.totalScore)

            this.setState({
                payFlag: true,
                userScore: uScore,
                exScore: exScore
            })
        } catch (error) {
            // console.log(this.props.totalScore);
            // console.log('检查积分不足情况:',error,this.props.totalScore);
            message.error('用户积分查询错误或用户积分不存在')
        }
    }
    forSure = async () => {
        // debugger
        let orderIdList = []
        this.setState({
            loading: true
        })
        console.log('下载列表打印：', this.props.orderList);
        if (this.props.orderList[0].shopId) {
            this.props.orderList.map(value => {
                orderIdList.push(value.shopId)
            })
            if (await payForOrder_cart(orderIdList)) {//积分足够下单成功
                await this.props.updatecart({})
                this.props.closePayModal()
                this.setState({
                    payFlag: false,
                    loading: false
                })
                message.success('恭喜您成功下单！可前往个人中心查看此订单详情。')
                this.props.init();
            } else {//积分不足下单失败
                message.error('积分不足下单失败')
                this.props.closePayModal()
                this.setState({
                    payFlag: false,
                    loading: false
                })
            }
        } else {
            // this.props.orderList.map(value => {
            //     orderIdList.push({
            //         fileName: value.name,
            //         fileSize: value.size,
            //         orderCreationUserId: store.getState().userReducer.get('user').toJS().userId,
            //         orderDownloadAddr: value.sourceUrl + `?filename=${value.name}` || value.url + `?filename=${value.name}`,
            //         resourceType: value.producetype,
            //         score: value.score
            //     })
            // })
            if (await payForOrder_search(this.returnDownloadList())) {
                await this.props.updatecart({})
                this.props.closePayModal()
                this.setState({
                    payFlag: false,
                    loading: false
                })
                message.success('恭喜您成功下单！可前往个人中心查看此订单详情。')
            } else {
                message.error('积分不足下单失败')
                this.props.closePayModal()
                this.setState({
                    payFlag: false,
                    loading: false
                })
            }
        }
    }

    returnDownloadList = () => {
        let { selectedtype, orderList, rules } = this.props
        let downloadList = []
        orderList.map(value => {
            let filename = value.producetype === "地表大气光谱特征数据" ? value.sitenumber : value.spectraldata;
            let orderItem = {
                "fileName": filename || value.name || value.dataname,
                "orderCreationUserId": this.props.user.userId,
            }
            switch (selectedtype) {
                case '0-2级数据':
                    // if (rules.selectSensoryType === '光学传感器') orderItem.resourceType = '光学卫星数据'
                    // if (rules.selectSensoryType === '雷达传感器') orderItem.resourceType = '微波卫星数据'
                    // if (rules.selectSensoryType === '大气传感器') orderItem.resourceType = '大气卫星数据'
                    orderItem.resourceType = rules.resourceType
                    break;
                case '3-5级产品':
                    rules.selectClass === '景产品' ?
                        orderItem.resourceType = rules.selectClass :
                        orderItem.resourceType = rules.resourceType
                    break;
                case '遥感特征数据':
                    orderItem.resourceType = value.resourceType
                    break;
                case '基础地理数据':
                    orderItem.resourceType = value.resourceType
                    break;
                default:
                    break;
            }
            downloadList.push(orderItem)
        })
        return downloadList
    }
    cancelSure = () => {
        this.setState({
            payFlag: false
        })
    }

    render() {
        const { userScore } = this.state;
        let footer1 = <div className='footer'>
            <div className='footer-text'>
                <div className='footer-font'><span
                    className='footer-num'>{this.props.orderList.length}</span>&nbsp;&nbsp;订单
                </div>
                <div className='footer-font'>共&nbsp;&nbsp;<span
                    className='footer-num'>{this.props.totalScore}</span>&nbsp;&nbsp;积分
                </div>
            </div>
            <div className='footer-button'>
                <Button size='large' onClick={this.props.closePayModal}>取消</Button>
                <Button onClick={this.payForOrder} type="primary" size='large'
                    title={this.returnDownLoadButtonDisabled() ? `当前用户积分为：${userScore}，不足以支付下载积分` : `当前用户积分为：${userScore}`}
                    disabled={this.returnDownLoadButtonDisabled()}>下载</Button>
            </div>
        </div>
        let footer2 = <div className='footer'>
            <div className='footer-text'>
                <div className='footer-font'>扣除后剩余 {this.state.exScore} 积分</div>
            </div>
            <div className='footer-button'>
                <Button size='large' onClick={this.cancelSure}>取消</Button>
                <Button onClick={this.forSure} type="primary" size='large' loading={this.state.loading}>确定</Button>
            </div>
        </div>
        return (
            <>
                <Modal
                    className='payModal'
                    visible={this.props.payModalVisible}
                    title='下载订单'
                    footer={footer1}
                    onCancel={this.props.closePayModal}
                >
                    {
                        this.props.orderList.map((value, index) => {
                            return <OrderEntity02
                                data={value}
                            ></OrderEntity02>
                        })
                    }
                </Modal>
                <Modal
                    className='payModal-sure'
                    visible={this.state.payFlag}
                    onOk={this.forSure}
                    footer={footer2}
                    centered={true}
                    onCancel={this.cancelSure}
                >
                    您目前的积分为 {this.state.userScore} ，确定扣除{this.props.totalScore}积分下单？
                </Modal>
            </>

        )
    }

    returnDownLoadButtonDisabled = () => {
        const { userScore } = this.state;
        const { totalScore } = this.props;
        if (userScore >= totalScore) {
            return false;
        } else {
            return true;
        }
    }
}

class OrderEntity02 extends React.Component {
    render = () => {
        let { pngUrl, fileName, score, productlevel, satelliteid, name, id, producetype } = this.props.data
        console.log("this.props.data", this.props.data);
        return (
            <div className='OrderEntity02-content'>
                <img className='OrderEntity02-img' src={pngUrl || defaultImg} />
                <div className='OrderEntity02-text'>
                    <div className='OrderEntity02-filName'>{fileName || name}</div>
                    <div className='OrderEntity02-satelliteId'>{satelliteid || producetype || id}</div>
                    <div className='OrderEntity02-productLevel'>{productlevel}</div>
                </div>
                <div className='OrderEntity02-score'>{score}<span className="small_text">&nbsp;积分</span></div>
            </div>
        )
    }
}

const mapState = (state) => ({ //返回值  对应的是  组件的props  
    user: state.userReducer.get('user').toJS()
})
const mapDispatch = (dispatch, ownProps) => ({})

export default connect(mapState, mapDispatch)(PayModal);


